import React, { useEffect, useState } from 'react';
import useSize from '../../../../hooks/useSize';
import { getCompanyAllPagination } from '../../../../services/companyService';
import { useToast } from '../../../components/Toats';
import { TableBody } from './components/TableBody';
import { useQuery } from 'react-query';
import { PaginationGlobal } from '../../../components/PaginationGlobal';
import { LoadingSpan } from '../../../components/Loadings/loadingSpan';
import { SearchInputV3 } from '../../../components/SearchInputV3';
import { KTSVG } from '../../../../../_metronic/helpers';
import { SelectGlobal } from '../../../components/SelectGlobal';
import { getUsersAll } from '../../../../services/usersService';
import { ModalUpdateCompany } from '../../../controlPanel/marksControl/tableCompanies/components/ModalEditCompany';

type Paginations = {
  page: number,
  limit: number,
  total: number,
  qtdPages: number
}

type SetPaginations = {
  start: number;
  end: number;
};


export function TableCompanies({myRefresh}: any) {
    const {width} = useSize();
    const { toggleToast } = useToast();
    const [showEditCompanyModal, setShowEditCompanyModal] = useState(false);
    const [editCompanyTab, setEditCompanyTab] = useState<'edit' | 'users'>('edit');
    const [myCompany, setMyCompany] = useState<any>(null);
    const [filterUser, setFilterUser] = useState<string | null>("");
    const [filterStatus, setFilterStatus] = useState<string | null>("");
    const [filterCorporateName, setFilterCorporateName] = useState<string>("");
    const [optionFilterUser, setOptionFilterUser] = useState<string>("nome");


    const [pagination, setPagination] = useState<Paginations>({
      page: 1,
      limit: 15,
      total: 0,
      qtdPages: 1
    });

    const [qtd, setQtd] = useState<SetPaginations>({
      start: 0,
      end: 15,
    });


    const { data: users, isLoading: loadingUsers } = useQuery<any>(
      ["getMyUsers"],
      async () => {
        const myUsers = await getUsersAll();
        return myUsers;
      },
      {
        onError: (error) => {
          console.log(error);
          toggleToast("Erro ao buscar empresas. ", "error")
        },
      }
    )

    const { data: companies, isLoading: loading, refetch: refreshCompanies } = useQuery<any>(
      ["getMyCompanies", myRefresh, filterCorporateName, filterUser, filterStatus, pagination.page],
      async () => {
        const myCompanies = await getCompanyAllPagination(
          pagination.limit,
          pagination.page,
          filterCorporateName,
          filterUser ? filterUser : undefined,
          filterStatus ? filterStatus : undefined,
          true
        );

        if(myCompanies){
          setPagination({...pagination, qtdPages: myCompanies.lastPage, total: myCompanies.total})
        }
        return myCompanies.data
      },
      {
        onError: (error) => {
          console.log(error);
          toggleToast("Erro ao buscar empresas. ", "error")
        },
      }
    )

    useEffect(() => {
      const start = (pagination.page - 1) * pagination.limit + 1;
      const end = Math.min(pagination.page * pagination.limit, pagination.total);
  
      setQtd({start: start, end: end === 0 ? pagination.limit : end})
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.page]);

    const refresh = () => {
      refreshCompanies();
    }

  return (
    <div className={`card card-xl-stretch mb-xl-8 mt-3`} style={{height: width > 1200 ? '72vh' : '68vh', paddingBottom: '1rem', marginBottom: width < 1200 ? "7rem" : ""}}>
      <div className='card-header border-0 pt-6 mb-5' style={{display: 'flex'}}>
        <div 
          style={{
            display: 'flex', 
            gap: '1rem',  
            justifyContent: 'space-between', 
            width: '100%',
            flexDirection: width > 1200 ? 'row' : 'column'
        }}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Lista de empresas</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Todas as empresas cadastradas no solar vision</span>
          </h3>

          <div style={{display: 'flex', gap: '1rem', alignItems: 'center', }}>
            <SearchInputV3
              className='form-control form-control-sm bg-light'
              placeholder={"Buscar por nome da corporação"}
              setMySearch={setFilterCorporateName}
              setPagination={setPagination}
              style={{ 
                width: width < 1200 ? "60%" : width < 1700 ? "200px" : "300px", 
                height: '3.5rem',
                flex: width < 1200 ? '1' : ''
              }}
            />

            <div>
              <div className="dropdown">
                <button 
                  type="button" 
                  className="btn btn-lg btn-light btn-active-color-primary btn-sm dropdown-toggle" 
                  data-bs-toggle="dropdown" 
                  aria-expanded="false" 
                  data-bs-auto-close="outside"
                >
                  <span><KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-3'/></span>
                </button>
                <div className="dropdown-menu dropdown-menu-end p-4" style={{width: 'auto', minWidth: '400px', maxWidth: '500px'}}>
                  <label className='form-label fw-bold' style={{marginTop: '0.5rem', marginBottom: '0.5rem'}}>Outros Filtros</label>
                  <div className='separator my-2'></div>

                  <div style={{marginTop: '0.5rem', marginBottom: '1rem'}}>
                    {/* <label className='form-label fs-7' style={{marginBottom: '0.5rem'}}>Colaborador</label> */}
                    <div>
                      <SelectGlobal 
                        //itens={collaborators}
                        itens={[{name: "ATIVADA"}, {name: "DESATIVADA"}]}
                        buttonAll={true}
                        textSearch={"Buscar status"}
                        textButtonInit={"Filtrar por status"}
                        labelKey='name'
                        valueKey='name'
                        //typeIcon='img'
                        setPagination={setPagination}
                        value={filterStatus ? filterStatus : ""}
                        className={"w-100"}
                        onChange={(value: string) => {
                          setFilterStatus ? setFilterStatus(value) : console.log('Sem função de filtro')
                        }}
                      />
                      {/* <select
                        className='form-select form-select-solid'
                        data-kt-select2='true'
                        data-placeholder='Select option'
                        data-allow-clear='true'
                        defaultValue={filterCollaborator !== "" ? filterCollaborator : ""}
                        value={filterCollaborator}
                        onChange={(e: any) => {
                          setFilterCollaborator(e.target.value);
                        }}
                      >
                        <option value={""}></option>
                        {collaborators && collaborators.map((collaborator: any) => {
                          return (
                            <option key={collaborator.id} value={collaborator.id}>{collaborator.name}</option>
                          )
                        })}
                        
                      </select> */}
                    </div>
                  </div>

                  <div style={{marginTop: '0.5rem', marginBottom: '1rem'}}>
                    {/* <label className='form-label fs-7' style={{marginBottom: '0.5rem'}}>Cliente</label> */}
                    <div style={{display: 'flex', gap: '0.5rem'}}>
                        <div style={{flex: 3}}>
                          <SelectGlobal 
                            //itens={clients}
                            itens={users}
                            buttonAll={true}
                            textSearch={`Buscar por ${optionFilterUser}`}
                            textButtonInit={`Filtrar por usuario (${optionFilterUser})`}
                            labelKey={`${optionFilterUser === "nome" ? "name" : "email"}`}
                            valueKey='id'
                            //typeIcon='img'
                            loading={loadingUsers}
                            setPagination={setPagination}
                            value={filterUser ? filterUser : ""}
                            className={"w-100"}
                            onChange={(value: string) => {
                              setFilterUser ? setFilterUser(value) : console.log('Sem função de filtro')
                            }}
                          />
                        </div>
                        <div style={{flex: 1}}>
                          <select
                            className='form-select form-select-solid form-select-sm'
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            value={optionFilterUser}
                            onChange={(e: any) => {
                              setOptionFilterUser(e.target.value);
                            }}
                          >
                            <option value={"nome"}>Nome</option>
                            <option value={"e-mail"}>E-mail</option>
                          </select>
                        </div>
                        
                      </div>
                  </div>

                  <div className='separator my-2'></div>

                  <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                      //href="#" 
                      className='btn btn-color-gray-600 btn-active-color-primary' 
                      onClick={() => {
                        setFilterUser(null)
                        setFilterStatus("")
                        // setFilterDateInit("")
                        // setFilterStatus("")
                        // setFilterCollaborator("")
                        // setFilterClient("")
                      }}>
                      Limpar todos os filtros <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
                    </button>
                  </div>

                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div className='card-body py-3' style={width < 1200 ? {height: '20rem', overflow: 'auto', paddingTop: '0rem'} : {overflow: 'auto'}}>
        {loading ?
          <LoadingSpan style={{marginLeft: '0.5rem'}}/>
        :
        <div className='table-responsive'>
          <table className='table table-row-dashed table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='text-muted text-start fw-bolder fs-7 text-uppercase gs-0'>
                {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-250px'>Nome</th>
                <th className='min-w-150px'>CNPJ</th>
                <th className='min-w-150px'>Data de criação</th>
                <th className='min-w-100px'>Usuário</th>
                <th className='min-w-100px'>Tipo</th>
                <th className='min-w-100px'>Status</th>
                <th className='min-w-200px'>Usinas Importadas</th>
                <th className='min-w-150px text-end'>Actions</th>
              </tr>
            </thead>

            <TableBody 
              companies={companies}
              setMyCompany={setMyCompany}
              refresh={refresh}
              setShowDeactiveAppModal={() => {
                setEditCompanyTab('users')
                setShowEditCompanyModal(true)
              }}
              setShowEditCompanyModal={() => {
                setEditCompanyTab('edit')
                setShowEditCompanyModal(true)
              }}
            />
          </table>
        </div>}
      </div>

      <div className='card-footer'>
        <PaginationGlobal 
            pagination={pagination}
            setPagination={setPagination}
            qtd={qtd}
        />
      </div>

      <ModalUpdateCompany 
        show={showEditCompanyModal}
        data={myCompany ? myCompany : undefined}
        id={myCompany ? myCompany.id : ""}
        initialTab={editCompanyTab}
        handleClose={() => {
          setMyCompany(null)
          setShowEditCompanyModal(false)
          setEditCompanyTab('edit')
          refresh()
        }} 
      />
    </div>
  );
}